/* eslint-disable */
import { makeStyles, RACCOLOR } from '@rentacenter/racstrap';
export const CostBasedPricingStyles = () => {
    const useClasses = makeStyles((theme) => ({
        '@global': {
            '*::-webkit-scrollbar': {
                width: '10px',
            },
            '*::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgb(189, 189, 196)',
                borderRadius: '20px',
                border: '3px solid rgb(206, 204, 201)',
            },
            '*::-webkit-scrollbar-track': {
                background: 'rgb(245, 243, 239)',

            }
        },
        pagePadding1: {
            padding: "0 1% 1% 1%",
            paddingTop: "35px",
            width: '100%'
        },
        mb15: {
            marginBottom: '15px'
        },
        floatLeft: {
            float: 'left',
        },

        floatRight: {
            float: 'right',
        },
        title4: {
            color: '#000',
            fontFamily: 'OpenSans-bold',
            fontWeight: "bold",
            fontSize: '18px',
            marginBottom: theme.typography.pxToRem(10),
        },
        title5: {
            color: '#000',
            fontFamily: 'OpenSans-semibold',
            fontWeight: 400,
            fontSize: '0.875rem',
            marginBottom: theme.typography.pxToRem(10),
        },
        title6: {
            color: '#000',
            fontFamily: 'OpenSans-bold',
            fontWeight: 400,
            fontSize: '0.875rem',
            marginBottom: theme.typography.pxToRem(10),
        },
        card: {
            borderRadius: theme.typography.pxToRem(15),
            boxShadow: '0 1px 4px 0 rgba(0,0,0,.074)',
            width: '100%'
        },
        mR1: {
            marginRight: '10px'
        },
        padding6: {
            padding: '10px 25px'
        },
        centerAlign: {
            textAlign: 'center',
        },
        mb4: {
            marginBottom: theme.typography.pxToRem(10),
        },
        mt3: {
            marginTop: theme.typography.pxToRem(25),
        },
        pricingGrid: {
            "& thead": {
                position: "sticky",
                top: "0",
                zIndex: "1",
                backgroundColor: "#FFF",
            },
            "& tr": {
                "& th": {
                    padding: "12px 20px !important",
                    backgroundColor: "#ffffff",
                    fontFamily: "OpenSans-bold",
                    fontSize: "0.8rem",
                },
                "& td": {
                    padding: "12px 20px !important",
                    fontFamily: "OpenSans-semibold",
                    color: "#3c454f",
                    fontSize: "0.8rem",
                },
                "& th:last-child": {
                    position: "sticky",
                    right: "0",
                    backgroundColor: "#FFF",
                    paddingLeft: '0px !important',
                    paddingRight: '0px !important',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    minHeight: '40px !important'
                },
                "& td:last-child": {
                    position: "sticky",
                    right: "0",
                    backgroundColor: "#FFF",
                    paddingLeft: '0px !important',
                    paddingRight: '0px !important',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end'
                },
            },
        },
        textSpaceNorecords: {
            textAlign: "center",
            width: "100%",
        },
        textcenterImage: {
            textAlign: "center",
            marginTop: theme.typography.pxToRem(20),
            width: "100%",
            fontFamily: "OpenSans-bold",
            fontSize: theme.typography.pxToRem(16),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        textcenterImage1: {
            textAlign: "center",
            marginTop: theme.typography.pxToRem(20),
            width: "100%",
            fontFamily: "OpenSans-bold",
            fontSize: theme.typography.pxToRem(16),
            justifyContent: "center",
            alignItems: "center",
        },
        gridLoader: {
            position: 'absolute',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            left: '50%'
        },
        whitebackground: {
            backgroundColor: "white"
        },
        textcenterNorecords: {
            textAlign: "center",
            marginTop: theme.typography.pxToRem(60),
            width: "100%",
            fontFamily: "OpenSans-regular",
            fontSize: theme.typography.pxToRem(14),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        racErrorIcon: {
            width: "50px",
        },
        title3: {
            color: '#000',
            marginBottom: theme.typography.pxToRem(10),
        },
        currencyInputStyle: {
            paddingBottom: '1px !important',
            "& div": {
                "& input": {
                    height: "21px",
                },
            },
            '& .MuiGrid-align-items-xs-flex-start': {
                display: 'flex !important',
                flexWrap: 'nowrap',
            },
            cursor: "pointer",
        },
        tooltipcss: {
            marginLeft: '4px',
            marginBottom: '-2px',
            top: '0',
            positon: 'absolute'
        },
        tooltipcss1: {
            backgroundColor: '#ECF0F3',
            color: 'black',
            top: '-10px'
        },
        tooltipStyling1: {
            color: '#ECF0F3'
        },
        width2: {
            width: '2%',
        },
        width6: {
            width: '6%',
        },
        cursorStyle: {
            cursor: 'pointer'
        },
        ml10: {
            marginLeft: '10px'
        },
        greyColor: {
            color: 'grey'
        },
        fs12: {
            fontSize: '12px'
        },
        h10: {
            height: '10px'
        },
        errorMessage: {
            fontSize: '0.8125rem',
            lineHeight: '1.21875rem',
            color: '#ef0000',
            fontWeight: 400
        },
        textBlue: {
            color: `${RACCOLOR.NORMAL_BLUE}`
        },
        ml2: {
            marginLeft: theme.typography.pxToRem(8),
        },
        textRight: {
            textAlign: "right",
        },
        pagination: {
            display: "flex",
            listStyle: "none",
            textDecoration: "none",
            fontFamily: "OpenSans-semibold",
            fontSize: theme.typography.pxToRem(14),
            justifyContent: "flex-end",
            cursor: "pointer",
        },
        paginationprevnext: {
            color: "#000",
            padding: "5px 17px",
            display: "inline-block",
        },
        paginationprevnextdisable: {
            color: "lightgray !important",
            padding: "5px 17px",
            display: "inline-block",
        },
        pageactive: {
            backgroundColor: "#2468FF",
            color: "#fff",
            borderRadius: "50%",
        },
        pagelink: {
            position: "relative",
            display: "block",
            textDecoration: "none",
            padding: "5px 0px",
            width: "29px",
            textAlign: "center",
        },
        masterLoader: {
            position: "fixed",
            backgroundColor: `${RACCOLOR.WASHED_BLACK}`,
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            opacity: 0.6,
            zIndex: 1000,
            textAlign: "center",
            margin: 0,
        },
        Loader: {
            display: "block",
            position: "fixed",
            zIndex: 1051,
            top: "50%",
            right: "50%",
        },
        businessValue: {
            zIndex: 3,
            '& input': {
                borderTopLeftRadius: '0px !important',
                borderBottomLeftRadius: '0px !important',
                textOverflow: 'ellipsis'
            },
        },
        prcingzoneMultiSelect: {
            "& .dropdown-container": {
                "& div": {
                    overflow: "hidden !important",
                },
                height: "31px",
            },
            "& .dropdown-heading": {
                height: "31px !important",
            },
            "& .dropdown-content": {
                borderRadius: "8px",
                boxShadow: "0 .125rem .25rem rgba(0,0,0,.075)!important",
                zIndex: "99",
            },
        },
        demo: {
            "& .dropdown-content": {
                "& .search": {
                    border: "1px solid #e3e3e3",
                },
            },
            "& .options": {
                overflowX: "hidden !important",
            },
        },
    }));
    const classes = useClasses();
    return classes;
}